/**
 * Cached loader for the Market Place securities payload.
 *
 * Same module-level cache + in-flight dedupe idiom as portfolioOptions.js.
 * Cleared on logout via AuthContext.clearTokens so a new user never sees the
 * previous user's holdings (data-isolation requirement).
 */
import { API_ENDPOINTS } from '../../../config/api';

let cache = null; // resolved /api/marketplace/securities payload
let inflight = null; // dedupes concurrent callers

function authHeader() {
  const token =
    localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function loadMarketplaceSecurities({ force = false } = {}) {
  if (!force && cache) return Promise.resolve(cache);
  if (!force && inflight) return inflight;
  inflight = fetch(API_ENDPOINTS.marketplace.securities, { headers: authHeader() })
    .then((res) => {
      if (!res.ok) throw new Error(`marketplace ${res.status}`);
      return res.json();
    })
    .then((data) => {
      cache = data;
      inflight = null;
      return data;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });
  return inflight;
}

/** Drop the cached payload (call on logout / token clear). */
export function clearMarketplaceSecurities() {
  cache = null;
  inflight = null;
}
